import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from '../create/components/round-form.schema';
import { RoundForm } from '../create/components/round-form';
import { useUpdateRoundMutation } from '../mutations';
import { useRoundDetailsQuery } from '../queries';
import { roundIdParamSchema } from '~/schemas';
import { useNavigate } from 'react-router';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { toast } from 'react-toastify';

export function Page() {
  const { roundId } = useParams(roundIdParamSchema.parse);
  const { data } = useRoundDetailsQuery(roundId);
  const navigate = useNavigate();

  const mutation = useUpdateRoundMutation();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync({ id: roundId, payload }), {
      success: 'Serieomgången har uppdaterats',
      pending: 'Uppdaterar serieomgång...',
    });
    navigate(-1);
  }

  if (!data) return false;

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera serieomgång" />

      <PageLayout.Section>
        <RoundForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          defaultValues={{
            name: data.name ?? '',
            start: data.start ?? '',
            end: data.end ?? '',
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
}
